import type { Heading } from "../lib/markdown";

interface TocSidebarProps {
  headings: Heading[];
  activeSlug: string | null;
  onNavigate: (slug: string) => void;
}

export default function TocSidebar({ headings, activeSlug, onNavigate }: TocSidebarProps) {
  if (headings.length === 0) return null;

  return (
    <nav aria-label="Chapters" className="text-sm">
      <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-muted">Chapters</p>
      <ul className="space-y-0.5 border-l border-border">
        {headings.map((h) => {
          const isActive = activeSlug === h.slug;
          return (
            <li key={h.slug}>
              <button
                type="button"
                onClick={() => onNavigate(h.slug)}
                aria-current={isActive ? "location" : undefined}
                className={
                  "-ml-px block w-full truncate border-l-2 py-1.5 pl-3 text-left transition-colors " +
                  (isActive ? "border-accent font-medium text-accent" : "border-transparent text-muted hover:text-text")
                }
                title={h.text}
              >
                {h.text}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
